/* Corlanza — visor 3D del cepillo (WebGL sin librerias). Si no hay WebGL, deja la imagen de respaldo. */
(function(){
  'use strict';

  function init(stage){
    if(stage.dataset.corInit) return;
    stage.dataset.corInit='1';
    var glCanvas=stage.querySelector('.cor-gl');
    var steamCanvas=stage.querySelector('.cor-steam');
    var hint=stage.querySelector('.hint');
    var fallback=stage.querySelector('.fallback');
    if(!glCanvas||!steamCanvas) return;

    var gl=null;
    try{ gl=glCanvas.getContext('webgl',{antialias:true,alpha:true,premultipliedAlpha:false,depth:true}); }catch(e){}
    if(!gl){ glCanvas.style.display='none'; steamCanvas.style.display='none'; if(hint) hint.style.display='none'; return; }
    if(fallback) fallback.style.display='none';

    var reduced=window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    function mIdent(){return [1,0,0,0, 0,1,0,0, 0,0,1,0, 0,0,0,1];}
    function mMul(a,b){var o=new Array(16);for(var c=0;c<4;c++)for(var r=0;r<4;r++){o[c*4+r]=a[0*4+r]*b[c*4+0]+a[1*4+r]*b[c*4+1]+a[2*4+r]*b[c*4+2]+a[3*4+r]*b[c*4+3];}return o;}
    function mTrans(x,y,z){var m=mIdent();m[12]=x;m[13]=y;m[14]=z;return m;}
    function mRotAxis(ax,ay,az,ang){var c=Math.cos(ang),s=Math.sin(ang),t=1-c;var l=Math.hypot(ax,ay,az)||1;ax/=l;ay/=l;az/=l;
      return [ax*ax*t+c, ay*ax*t+az*s, az*ax*t-ay*s,0, ax*ay*t-az*s, ay*ay*t+c, az*ay*t+ax*s,0, ax*az*t+ay*s, ay*az*t-ax*s, az*az*t+c,0, 0,0,0,1];}
    function mPersp(fovy,asp,n,f){var t=1/Math.tan(fovy/2);return [t/asp,0,0,0, 0,t,0,0, 0,0,(f+n)/(n-f),-1, 0,0,(2*f*n)/(n-f),0];}
    function mLookAt(e,c,u){var z=vNorm([e[0]-c[0],e[1]-c[1],e[2]-c[2]]);var x=vNorm(vCross(u,z));var y=vCross(z,x);
      return [x[0],y[0],z[0],0, x[1],y[1],z[1],0, x[2],y[2],z[2],0, -vDot(x,e),-vDot(y,e),-vDot(z,e),1];}
    function vCross(a,b){return [a[1]*b[2]-a[2]*b[1], a[2]*b[0]-a[0]*b[2], a[0]*b[1]-a[1]*b[0]];}
    function vDot(a,b){return a[0]*b[0]+a[1]*b[1]+a[2]*b[2];}
    function vNorm(a){var l=Math.hypot(a[0],a[1],a[2])||1;return [a[0]/l,a[1]/l,a[2]/l];}
    function m3FromM4(m){return [m[0],m[1],m[2], m[4],m[5],m[6], m[8],m[9],m[10]];}
    function tP(m,p){return [m[0]*p[0]+m[4]*p[1]+m[8]*p[2]+m[12], m[1]*p[0]+m[5]*p[1]+m[9]*p[2]+m[13], m[2]*p[0]+m[6]*p[1]+m[10]*p[2]+m[14]];}
    function tD(m,v){return [m[0]*v[0]+m[4]*v[1]+m[8]*v[2], m[1]*v[0]+m[5]*v[1]+m[9]*v[2], m[2]*v[0]+m[6]*v[1]+m[10]*v[2]];}

    function gridSurface(fn,uN,vN,uA,uB,vA,vB){
      var rows=[],i,j;
      var du=(uB-uA)*1e-3, dv=(vB-vA)*1e-3;
      for(i=0;i<=uN;i++){
        var u=uA+(uB-uA)*i/uN, row=[];
        for(j=0;j<=vN;j++){
          var v=vA+(vB-vA)*j/vN;
          var p=fn(u,v), pu=fn(u+du,v), pv=fn(u,v+dv);
          var tu=[pu[0]-p[0],pu[1]-p[1],pu[2]-p[2]];
          var tv=[pv[0]-p[0],pv[1]-p[1],pv[2]-p[2]];
          row.push({p:p,n:vNorm(vCross(tu,tv))});
        }
        rows.push(row);
      }
      var pos=[],nrm=[];
      for(i=0;i<uN;i++)for(j=0;j<vN;j++){
        var a=rows[i][j],b=rows[i+1][j],c=rows[i+1][j+1],d=rows[i][j+1];
        var q=[a,b,c,a,c,d];
        for(var k=0;k<6;k++){pos.push(q[k].p[0],q[k].p[1],q[k].p[2]);nrm.push(q[k].n[0],q[k].n[1],q[k].n[2]);}
      }
      return {pos:pos,nrm:nrm};
    }
    function sgnpow(t,e){return (t<0?-1:1)*Math.pow(Math.abs(t),e);}
    function superellipsoid(A,B,C,e,uN,vN){
      var eps=0.02;
      return gridSurface(function(u,v){
        var cu=sgnpow(Math.cos(u),e), su=sgnpow(Math.sin(u),e), cv=sgnpow(Math.cos(v),e), sv=sgnpow(Math.sin(v),e);
        return [A*cu*cv, B*su, C*cu*sv];
      }, uN,vN, -Math.PI/2+eps, Math.PI/2-eps, -Math.PI, Math.PI);
    }
    function torus(R,r,uN,vN){
      return gridSurface(function(u,v){
        return [(R+r*Math.cos(v))*Math.cos(u), (R+r*Math.cos(v))*Math.sin(u), r*Math.sin(v)];
      }, uN,vN, 0, Math.PI*2, 0, Math.PI*2);
    }
    function cone(R,H,seg){
      return gridSurface(function(u,v){
        var rr=R*(1-u);
        return [rr*Math.cos(v), rr*Math.sin(v), H*u];
      }, 2, seg, 0,1, 0,Math.PI*2);
    }
    function bake(dst, geo, m4){
      var m3=m3FromM4(m4), i;
      for(i=0;i<geo.pos.length;i+=3){
        var p=tP(m4,[geo.pos[i],geo.pos[i+1],geo.pos[i+2]]);
        var n=vNorm(tD(m3,[geo.nrm[i],geo.nrm[i+1],geo.nrm[i+2]]));
        dst.pos.push(p[0],p[1],p[2]);dst.nrm.push(n[0],n[1],n[2]);
      }
    }

    var beige={pos:[],nrm:[]}, orange={pos:[],nrm:[]}, dark={pos:[],nrm:[]}, brush={pos:[],nrm:[]};
    var A=0.62, B=1.12, C=0.42;
    bake(beige, superellipsoid(A,B,C,0.42,54,54), mIdent());
    bake(beige, superellipsoid(0.24,0.26,0.30,0.5,20,20), mTrans(0,-1.18,0.02));
    bake(beige, torus(0.5,0.145,44,20), mTrans(0,-1.72,0));
    for(var rib=0; rib<7; rib++){
      var ry=-0.28-rib*0.11;
      bake(beige, superellipsoid(0.035,0.020,0.30,0.4,5,10), mTrans( A-0.015, ry, 0));
      bake(beige, superellipsoid(0.035,0.020,0.30,0.4,5,10), mTrans(-(A-0.015), ry, 0));
    }
    bake(orange, superellipsoid(0.52,0.95,0.13,0.35,46,50), mTrans(0,0,0.34));
    var holeC=[0,0.06];
    bake(dark,   superellipsoid(0.085,0.085,0.05,0.7,20,16), mTrans(holeC[0],holeC[1],0.44));
    bake(orange, torus(0.115,0.03,28,12),                    mTrans(holeC[0],holeC[1],0.50));
    var gx, gy, step=0.132;
    for(gx=-0.46; gx<=0.46; gx+=step){
      var off=(Math.round((gx+0.46)/step)%2)*step*0.5;
      for(gy=-0.86+off; gy<=0.86; gy+=step){
        var e2=(gx/0.46)*(gx/0.46)+(gy/0.90)*(gy/0.90);
        if(e2>1.0) continue;
        if(Math.hypot(gx-holeC[0], gy-holeC[1])<0.20) continue;
        var bz=0.47-0.06*e2;
        var dir=vNorm([gx*0.26, gy*0.18, 1]);
        var axis=vCross([0,0,1],dir), an=Math.acos(Math.max(-1,Math.min(1,dir[2])));
        var rot=(Math.hypot(axis[0],axis[1],axis[2])<1e-5)?mIdent():mRotAxis(axis[0],axis[1],axis[2],an);
        bake(brush, cone(0.05,0.225,8), mMul(mTrans(gx,gy,bz), rot));
      }
    }
    bake(orange, superellipsoid(0.27,0.27,0.05,1.0,30,22), mTrans(0,0.12,-(C+0.02)));
    bake(dark,   torus(0.27,0.012,30,10),                   mTrans(0,0.12,-(C+0.05)));

    function makeBuf(arr){var b=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(arr),gl.STATIC_DRAW);return b;}
    var beigePos=makeBuf(beige.pos), beigeNrm=makeBuf(beige.nrm), beigeCount=beige.pos.length/3;
    var orangePos=makeBuf(orange.pos), orangeNrm=makeBuf(orange.nrm), orangeCount=orange.pos.length/3;
    var darkPos=makeBuf(dark.pos), darkNrm=makeBuf(dark.nrm), darkCount=dark.pos.length/3;
    var brushPos=makeBuf(brush.pos), brushNrm=makeBuf(brush.nrm), brushCount=brush.pos.length/3;

    var vsrc='attribute vec3 aPos;attribute vec3 aNorm;uniform mat4 uProj,uView,uModel;uniform mat3 uNorm;'+
      'varying vec3 vN,vW;void main(){vec4 w=uModel*vec4(aPos,1.0);vW=w.xyz;vN=normalize(uNorm*aNorm);gl_Position=uProj*uView*w;}';
    var fsrc='precision highp float;varying vec3 vN,vW;uniform vec3 uColor,uCam;uniform float uShine,uSpec;'+
      'void main(){vec3 V=normalize(uCam-vW);vec3 N=normalize(vN);N*=(dot(N,V)<0.0?-1.0:1.0);'+
      'vec3 L1=normalize(vec3(0.45,0.95,0.75));vec3 L2=normalize(vec3(-0.7,0.25,-0.35));'+
      'float d1=max(dot(N,L1),0.0);float d2=max(dot(N,L2),0.0)*0.32;'+
      'vec3 H=normalize(L1+V);float sp=pow(max(dot(N,H),0.0),uShine)*uSpec*d1;'+
      'float rim=pow(1.0-max(dot(N,V),0.0),3.0)*0.22;'+
      'vec3 col=uColor*(0.44+0.82*d1+d2)+vec3(1.0)*sp+vec3(1.0)*rim;'+
      'gl_FragColor=vec4(col,1.0);}';
    function sh(t,s){var o=gl.createShader(t);gl.shaderSource(o,s);gl.compileShader(o);return o;}
    var prog=gl.createProgram();gl.attachShader(prog,sh(gl.VERTEX_SHADER,vsrc));gl.attachShader(prog,sh(gl.FRAGMENT_SHADER,fsrc));gl.linkProgram(prog);gl.useProgram(prog);
    var aPos=gl.getAttribLocation(prog,'aPos'), aNorm=gl.getAttribLocation(prog,'aNorm');
    var uProj=gl.getUniformLocation(prog,'uProj'), uView=gl.getUniformLocation(prog,'uView'), uModel=gl.getUniformLocation(prog,'uModel'),
        uNorm=gl.getUniformLocation(prog,'uNorm'), uColor=gl.getUniformLocation(prog,'uColor'), uCam=gl.getUniformLocation(prog,'uCam'),
        uShine=gl.getUniformLocation(prog,'uShine'), uSpec=gl.getUniformLocation(prog,'uSpec');
    gl.enableVertexAttribArray(aPos);gl.enableVertexAttribArray(aNorm);
    gl.enable(gl.DEPTH_TEST);

    var az=-0.62, el=0.16, dist=5.4, target=[0,-0.25,0];
    var dragging=false, lastX=0, lastY=0, autoOn=!reduced;
    function pd(x,y){dragging=true;lastX=x;lastY=y;if(hint)hint.style.opacity='0';}
    function pm(x,y){if(!dragging)return;az-=(x-lastX)*0.008;el+=(y-lastY)*0.008;el=Math.max(-0.5,Math.min(0.95,el));lastX=x;lastY=y;}
    function pu(){dragging=false;}
    glCanvas.addEventListener('mousedown',function(e){pd(e.clientX,e.clientY);});
    window.addEventListener('mousemove',function(e){pm(e.clientX,e.clientY);});
    window.addEventListener('mouseup',pu);
    glCanvas.addEventListener('touchstart',function(e){var t=e.touches[0];pd(t.clientX,t.clientY);},{passive:true});
    glCanvas.addEventListener('touchmove',function(e){var t=e.touches[0];pm(t.clientX,t.clientY);e.preventDefault();},{passive:false});
    glCanvas.addEventListener('touchend',pu);

    var sctx=steamCanvas.getContext('2d');
    var puffs=[], lastEmit=0, W=1, H=1, DPR=1;
    var HOLE=[0,0.06,0.52];
    function emit(){
      for(var i=0;i<4;i++){
        var dx=(Math.random()-0.5)*0.12, dy=(Math.random()-0.5)*0.10, dz=1.0;
        var l=Math.hypot(dx,dy,dz), sp=1.38+Math.random()*0.4;
        puffs.push({p:[HOLE[0],HOLE[1],HOLE[2]], v:[dx/l*sp,dy/l*sp,dz/l*sp], age:0, life:950+Math.random()*540, r0:0.045+Math.random()*0.03});
      }
    }
    function drawSteam(dt, proj, view){
      sctx.clearRect(0,0,steamCanvas.width,steamCanvas.height);
      sctx.save();sctx.scale(DPR,DPR);
      for(var i=puffs.length-1;i>=0;i--){var p=puffs[i];p.age+=dt;if(p.age>=p.life){puffs.splice(i,1);continue;}
        var k=p.age/p.life;
        p.p[0]+=p.v[0]*dt*0.001; p.p[1]+=p.v[1]*dt*0.001; p.p[2]+=p.v[2]*dt*0.001;
        var wv=tP(view,p.p), cw=-wv[2]; if(cw<=0.05) continue;
        var sx=((proj[0]*wv[0])/cw*0.5+0.5)*W, sy=(1-((proj[5]*wv[1])/cw*0.5+0.5))*H;
        var wr=p.r0+k*0.40;
        var rpx=Math.max(2, wr*proj[5]/cw*(H*0.5));
        var alpha=Math.sin(Math.min(1,k)*Math.PI)*0.5;
        var g=sctx.createRadialGradient(sx,sy,0,sx,sy,rpx);
        g.addColorStop(0,'rgba(158,216,245,'+alpha+')');g.addColorStop(0.45,'rgba(92,180,223,'+(alpha*0.66)+')');g.addColorStop(1,'rgba(92,180,223,0)');
        sctx.fillStyle=g;sctx.beginPath();sctx.arc(sx,sy,rpx,0,6.2832);sctx.fill();
      }
      sctx.restore();
    }

    function resize(){
      DPR=Math.min(window.devicePixelRatio||1,2);
      var w=stage.clientWidth, h=stage.clientHeight; W=w;H=h;
      glCanvas.width=w*DPR;glCanvas.height=h*DPR;
      steamCanvas.width=w*DPR;steamCanvas.height=h*DPR;
      gl.viewport(0,0,glCanvas.width,glCanvas.height);
    }
    window.addEventListener('resize',resize);

    function drawGroup(posB,nrmB,count,color,shine,spec){
      gl.bindBuffer(gl.ARRAY_BUFFER,posB);gl.vertexAttribPointer(aPos,3,gl.FLOAT,false,0,0);
      gl.bindBuffer(gl.ARRAY_BUFFER,nrmB);gl.vertexAttribPointer(aNorm,3,gl.FLOAT,false,0,0);
      gl.uniform3fv(uColor,color);gl.uniform1f(uShine,shine);gl.uniform1f(uSpec,spec);
      gl.drawArrays(gl.TRIANGLES,0,count);
    }

    /* Solo dibuja mientras la seccion esta en pantalla: ahorra bateria en movil. */
    var visible=true;
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){ visible=en[0].isIntersecting; },{threshold:0.05}).observe(stage);
    }

    var prev=0;
    function frame(t){
      requestAnimationFrame(frame);
      if(!visible){ prev=t; return; }
      var dt=prev?Math.min(t-prev,50):16; prev=t;
      if(autoOn && !dragging){az-=0.003*(dt/16);}
      var asp=glCanvas.width/glCanvas.height;
      var proj=mPersp(1.02,asp,0.1,50);
      var cam=[target[0]+dist*Math.cos(el)*Math.sin(az), target[1]+dist*Math.sin(el), target[2]+dist*Math.cos(el)*Math.cos(az)];
      var view=mLookAt(cam,target,[0,1,0]);
      var model=mIdent();
      gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
      gl.useProgram(prog);
      gl.uniformMatrix4fv(uProj,false,new Float32Array(proj));
      gl.uniformMatrix4fv(uView,false,new Float32Array(view));
      gl.uniformMatrix4fv(uModel,false,new Float32Array(model));
      gl.uniformMatrix3fv(uNorm,false,new Float32Array(m3FromM4(model)));
      gl.uniform3fv(uCam,cam);
      drawGroup(beigePos,beigeNrm,beigeCount,[0.845,0.815,0.735],12.0,0.20);
      drawGroup(orangePos,orangeNrm,orangeCount,[0.925,0.535,0.225],22.0,0.36);
      drawGroup(darkPos,darkNrm,darkCount,[0.17,0.13,0.11],8.0,0.12);
      drawGroup(brushPos,brushNrm,brushCount,[0.97,0.605,0.29],26.0,0.44);
      if(!reduced){
        if(cam[2]-HOLE[2]>0.25){
          if(t-lastEmit>72){lastEmit=t; emit();}
          drawSteam(dt, proj, view);
        } else { puffs.length=0; sctx.clearRect(0,0,steamCanvas.width,steamCanvas.height); }
      }
    }
    resize();
    gl.clearColor(0,0,0,0);
    requestAnimationFrame(frame);
  }

  function boot(root){
    [].slice.call((root||document).querySelectorAll('.corlanza .stage[data-cor-3d]')).forEach(init);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot();});
  else boot();
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
